import { defineStore } from 'pinia';

interface ClevertapState {
    fromTo: any | null;
    listInforFromSearch: any | null;
}

export const useClevertapStore = defineStore('clevertap', {
    state: (): ClevertapState => ({
        fromTo: null,
        listInforFromSearch: null
    }),

    getters: {
        getFromtTo(state) {
            return state.fromTo;
        },
        getInforFromSearch(state) {
            return state.listInforFromSearch;
        },
    },

    actions: {
        // Clevertap search product
        async productSearchCleverTap(dataClever: any) {
            console.log('Products Searched: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Products Searched', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap product list viewed
        async productListViewdCleverTap(dataClever: any) {
            console.log('Product List Viewed: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Product List Viewed', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Product List Filtered
        async productListFilterCleverTap(dataClever: any) {
            console.log('Product List Filtered: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Product List Filtered', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Clevertap Product Viewed
        async productViewdCleverTap(dataClever: any) {
            console.log('Product Viewing Started: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Product Viewing Started', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Item Viewing Started
        async itemViewStartedCleverTap(dataClever: any) {
            console.log('Item Viewing Started: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Item Viewing Started', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Track Order
        async trackingOrderCleverTap(dataClever: any) {
            console.log('Track Order: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Track Order', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }

        },

        // Clevertap Voucher Collected
        async voucherCollectedCleverTap(dataClever: any) {
            console.log('Voucher Collected: ', dataClever);
            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Voucher Collected', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Product Added to Cart
        async productAddToCartCleverTap(dataClever: any) {
            console.log('Item Added to Cart: ', dataClever);
            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Item Added to Cart', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Item Removed from Cart
        async productRemovedFromCartCleverTap(dataClever: any) {
            console.log('Item Removed from Cart: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Item Removed from Cart', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Cart Viewed
        async cartViewCleverTap(dataClever: any) {
            console.log('Cart Viewed: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Cart Viewed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Checkout Started
        async checkoutStartedCleverTap(dataClever: any) {
            console.log('Checkout Started: ', dataClever);

            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Checkout Started', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Payment & Shipping Info Added
        async paymentsShippingInforCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Payment & Shipping Info Added', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Order Created
        async orderCreatedCleverTap(dataClever: any) {
            console.log('Order Created: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Order Created', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Product Add To Wish List
        async productAddToWishListCleverTap(dataClever: any) {
            console.log('Product Added to Wishlist ', dataClever);
            try {
                setTimeout(() => {
                    dataClever?.clevertap.event.push('Product Added to Wishlist', dataClever.data);
                }, 500);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Product Remove From Wish List
        async productRemoveFromToWishCleverTap(dataClever: any) {
            console.log('Product Removed from Wishlist: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Product Removed from Wishlist', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Product Add From Wish List to Cart
        async productAddFromWishCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Wishlist Product Added to Cart', {
                    product_id: dataClever?.product?.parentSku ? dataClever?.product?.parentSku : dataClever?.product?.sku,
                    item_name: dataClever?.product?.name,
                    product_currency: 'VND',
                    product_price: dataClever?.product?.final_price ? dataClever?.product?.final_price : dataClever?.product?.price_incl_tax,
                    product_quantity: 1,
                    cart_id: dataClever?.cart_id,
                    item_size: dataClever?.selectedOption?.color?.label,
                    action_placement: dataClever?.action_placement
                });
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Voucher Entered
        async couponEnteredCleverTap(dataClever: any) {
            console.log('Voucher Entered: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Voucher Entered', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Voucher Applied
        async couponAppliedSuccessCleverTap(dataClever: any) {
            console.log('Voucher Applied: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Voucher Applied', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Voucher Denied
        async couponDeniedCleverTap(dataClever: any) {
            console.log('Voucher Denied: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Voucher Denied', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Voucher Removed
        async couponRemovedCleverTap(dataClever: any) {
            console.log('Voucher Removed: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Voucher Removed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap Error Website
        async errorWebsiteCleverTap(dataClever: any) {
            try {
                // Commented out in original code
                // dataClever?.clevertap.event.push('Error Website', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap User Login
        async userloginWebsiteCleverTap(dataClever: any) {
            console.log('userloginWebsiteCleverTap: ', dataClever);

            try {
                dataClever?.clevertap.onUserLogin.push(dataClever.infor);
            } catch (error) {
                // Error handling
            }
        },

        // Clevertap User Update
        async userUpdateWebsiteCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.profile.push(dataClever.infor);
            } catch (error) {
                // Error handling
            }
        },

        // Page View
        async pageViewCleverTap(dataClever: any) {
            console.log('Page Viewed: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Page Viewed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Page View
        async utmVisitedCleverTap(dataClever: any) {
            console.log('UTM Visited: ', dataClever);

            try {
                dataClever?.clevertap.event.push('UTM Visited', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Signup Successful
        async signupSuccessCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Signup Successful', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Signup Failed
        async signupFailedCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Signup Failed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Login Successful
        async loginSuccessCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Login Successful', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Login Failed
        async loginFailCleverTap(dataClever: any) {
            try {
                dataClever?.clevertap.event.push('Login Failed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Edit Profile
        async editProfileCleverTap(dataClever: any) {
            console.log('Edit Profile: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Edit Profile', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Email subscriber
        async emailSubscriberCleverTap(dataClever: any) {
            console.log('Email Submit: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Email Submit', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Store List Viewed
        async storeListViewedCleverTap(dataClever: any) {
            console.log('Store List Viewed: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Store List Viewed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Store Detail Viewed
        async storeDetailViewedCleverTap(dataClever: any) {
            console.log('Store Detail Viewed: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Store Detail Viewed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Action set from to
        async actionFromTo(payload: any) {
            try {
                this.fromTo = payload;
            } catch (error) {
                // Error handling
            }
        },

        // Item Checkout Started
        async itemCheckoutStartedCleverTap(dataClever: any) {
            console.log('itemCheckoutStartedCleverTap: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Item Checkout Started', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // New Address Added
        async newAddressAddedCleverTap(dataClever: any) {
            console.log('newAddressAddedCleverTap: ', dataClever);
            try {
                dataClever?.clevertap.event.push('New Address Added', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Payment Selected
        async paymentSelectedCleverTap(dataClever: any) {
            console.log('paymentSelectedCleverTap: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Payment Selected', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Payment Successful
        async paymentSuccessfulCleverTap(dataClever: any) {
            console.log('paymentSuccessfulCleverTap: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Payment Successful', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Payment Failed
        async paymentFailedCleverTap(dataClever: any) {
            console.log('paymentFailedCleverTap: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Payment Failed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },

        // Item Available Store Result
        async itemAvailableStoreCleverTap(dataClever: any) {
            console.log('Item Available Store Result: ', dataClever);

            try {
                dataClever?.clevertap.event.push('Item Available Store Result', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Login  successful
        async loginSuccessfulCleverTap(dataClever: any) {
            console.log('Login  successful: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Login  successful', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Login  successful
        async loginFailedCleverTap(dataClever: any) {
            console.log('Login Failed: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Login Failed', dataClever.data);
            } catch (error) {
                // Error handling
            }
        },
        // Popup Promotion
        async popupPromotionCleverTap(dataClever: any) {
            console.log('Popup Promotion: ', dataClever);
            try {
                dataClever?.clevertap.event.push('Popup Promotion', dataClever.data);
            } catch (error) {
                console.log('error: ', error);
                // Error handling
            }
        },

        // Set search info for tracking
        setInforFromSearch(payload: any) {
            this.listInforFromSearch = payload;
        }
    },
});
